import {DoccliService} from '../../../../providers/DoccliService.js';
const doccliService = new DoccliService();

export default {
  name: "RecapScanOkForToken",
   data () {
    return {
      token:null,
      callbackUrl:null,
      callbackLibelle:null,
    }
  },
  mounted: function () {
    this.token = this.$root.token;
    this.callbackUrl = this.$root.callbackUrl;   
    this.callbackLibelle = this.$root.callbackLibelle; 
    this.$root.logoutToken();
  },
  updated: function () {
    setTimeout(()=>{
      this.callback();
      //alert(0);
   },10000);
  },

  methods: {
    sendResponseCallBack:function(){
      this.token = this.$root.token;
      this.callbackUrl = this.$root.callbackUrl;
      this.callbackLibelle = this.$root.callbackLibelle;
      this.loading = true;
      doccliService.sendResponseCallBack(this.token).then(res => {
        
           this.loading = false;
           console.log(res)
         
        })
        .catch((error) => {
          this.loading = false;
          this.$dialog.notify.error(this.$root.errorMessage, {
            position: "bottom-right",
            timeout: 5000,
          });
          return error;
        });

      
    },
    callback(){
      if(this.callbackUrl)
        window.location.href=this.callbackUrl;
    
    }
  }
}